import { Box } from "@mui/material";
import React from "react";
import Navbar from "../Components/Navbar";
import Banner from "../Components/Banner";
import EightDimensions from "../Components/EightDimensions";
import AboutUs from "../Components/AboutUs";
import Portfolio from "../Components/Portfolio";
import Team from "../Components/Team";
import Footer from "../Components/Footer";
import LatestNews from "../Components/LatestNews";
import Affiliations from "../Components/Affiliations";

const LandinPage = () => {
  return (
    <Box>
      <Navbar />
      <Banner />
      <EightDimensions />
      <AboutUs />
      <Portfolio />
      <Team />
      <LatestNews />
      <Affiliations />
      <Footer />
    </Box>
  );
};

export default LandinPage;
